import React from 'react';
import { TextField, MenuItem, CircularProgress } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';
import { updateVendorIdentification } from '../../../state/vendorSlice';
import { useGetVendorStatusOptionsQuery } from '../../../../../services/DimensionService/dimensionApi';

const VendorStatusEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentVendor } = useAppSelector(state => state.vendor);
  const { data: statusOptions = [], isLoading } = useGetVendorStatusOptionsQuery();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateVendorIdentification({ status: event.target.value }));
  };

  return (
    <TextField
      label="Status"
      size="small"
      required
      fullWidth
      select
      value={currentVendor?.status || ''}
      onChange={handleChange}
      disabled={isLoading}
      InputProps={{
        endAdornment: isLoading ? <CircularProgress size={16} sx={{ mr: 2 }} /> : undefined,
      }}
    >
      {statusOptions.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.name}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default VendorStatusEdit;
